import { render, staticRenderFns } from "./BackgroundLayout.vue?vue&type=template&id=ed3f482e&scoped=true&functional=true&"
var script = {}
import style0 from "./BackgroundLayout.vue?vue&type=style&index=0&id=ed3f482e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "ed3f482e",
  null
  
)

export default component.exports